exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_audio_2lfsESJ6Pty7epMlXkVKVz {\n  width: 100%;\n  height: 54px;\n  float: left;\n  clear: both;\n  margin-bottom: 20px;\n}\n\n.IA_iframeOverlay_3XrA_MEXMVwCI2dvEspdET {\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  position: relative;\n}\n\n.IA_dropZones_2bWNtDmrBBBHw9xnM9xHP_ {\n  width: 100%;\n  height: 20px;\n  border: 1px dashed #e0e0e0;\n  border-radius: 5px;\n  background-color: #f6f6f6;\n  float: left;\n  position: relative;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_audio": "IA_audio_2lfsESJ6Pty7epMlXkVKVz",
	"IA_iframeOverlay": "IA_iframeOverlay_3XrA_MEXMVwCI2dvEspdET",
	"IA_dropZones": "IA_dropZones_2bWNtDmrBBBHw9xnM9xHP_"
};